/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentGeometryGeometriesInnerOneOf
 */
export interface EquipmentGeometryGeometriesInnerOneOf {
    /**
     * 
     * @type {EquipmentGeometryGeometriesInnerOneOfTypeEnum}
     * @memberof EquipmentGeometryGeometriesInnerOneOf
     */
    type: EquipmentGeometryGeometriesInnerOneOfTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof EquipmentGeometryGeometriesInnerOneOf
     */
    coordinates: Array<number>;
}


/**
 * @export
 */
export const EquipmentGeometryGeometriesInnerOneOfTypeEnum = {
    Point: 'Point'
} as const;
export type EquipmentGeometryGeometriesInnerOneOfTypeEnum = typeof EquipmentGeometryGeometriesInnerOneOfTypeEnum[keyof typeof EquipmentGeometryGeometriesInnerOneOfTypeEnum];


/**
 * Check if a given object implements the EquipmentGeometryGeometriesInnerOneOf interface.
 */
export function instanceOfEquipmentGeometryGeometriesInnerOneOf(value: object): value is EquipmentGeometryGeometriesInnerOneOf {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'Point') return false;
    
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function EquipmentGeometryGeometriesInnerOneOfFromJSON(json: any): EquipmentGeometryGeometriesInnerOneOf {
    return EquipmentGeometryGeometriesInnerOneOfFromJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentGeometryGeometriesInnerOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function EquipmentGeometryGeometriesInnerOneOfToJSON(json: any): EquipmentGeometryGeometriesInnerOneOf {
    return EquipmentGeometryGeometriesInnerOneOfToJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOfToJSONTyped(value?: EquipmentGeometryGeometriesInnerOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

